// import history from '@/utils/history';
import codeMessage from "./codeMessage";
import { toast } from "react-toastify";

const errorHandler = (error, notify = true) => {
  const { response } = error;
  if (response && response.status) {
    const message = response?.data && response?.data?.Error?.Message;
    const errorText = message || codeMessage[response.status];
    const { status } = response;
    if (notify) {
      toast.error(errorText);
    }
    // if (status == 404 || status == 401) {
    //   localStorage.clear();
    //   window.location.href = "/";
    // }
    return response.data;
    // Notification.config({
    // 	duration: 10,
    // });
    // Notification.error({
    // 	message: `Request error ${status}`,
    // 	description: errorText,
    // });
  } else {
    const message = response?.data && response?.data?.Error?.Message;

    const errorText = message || codeMessage[response.status];
    const { status } = response;
    if (notify) {
      toast.error(errorText);
    }
    return {
      success: false,
      result: null,
      message: "Cannot connect to the server, Check your internet network",
    };
    // notification.config({
    // 	duration: 5,
    // });
    // notification.error({
    // 	message: 'No internet connection',
    // 	description: 'Cannot connect to the server, Check your internet network',
    // });
  }
};

export default errorHandler;
